import React, { useMemo } from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import PageHero from './components/PageHero'
import { getTod } from '../data/loadData'
import { cleanHtml } from '../data/html'
import { upper } from '../data/dates'
import './Pages.css'

const isEnglish = (entry) => /^about\b/i.test(entry.aciklama.replace(/<[^>]+>/g, '').trim())

export default function Tod() {
  const { history, plays, english } = useMemo(() => {
    const entries = getTod().map((entry) => ({
      ...entry,
      title: String(entry.oyun || '').trim(),
      photo: entry.afis ? `images/${entry.afis}` : '',
      html: cleanHtml(entry.aciklama, { dropHeading: true }),
    }))
    return {
      history: entries.find((entry) => !entry.topluluk),
      english: entries.find((entry) => entry.topluluk && isEnglish(entry)),
      plays: entries.filter((entry) => entry.topluluk && !isEnglish(entry)),
    }
  }, [])

  return (
    <React.Fragment>
      <Header />
      <PageHero
        eyebrow='1987’den beri · Ankara'
        title='Tiyatro Özgün Deneme'
        lede='Yeşim Eyüboğlu tarafından kurulan, edebi eserleri sahneye taşıyan ve ETHOS Ankara Uluslararası Tiyatro Festivali’ni yürüten topluluk.'
        aside={
          <div className='tod-emblem'>
            <img src='images/tod.jpg' alt='Tiyatro Özgün Deneme amblemi' />
          </div>
        }
      />

      <div className='pg' lang='tr'>
        {history ? (
          <section className='pg-paper pg-block' aria-labelledby='tod-history-title'>
            <div className='container pg-split'>
              <div className='pg-sticky'>
                <p className='pg-label'>Topluluk</p>
                <h2 id='tod-history-title' className='pg-heading'>TARİHÇE</h2>
                <blockquote className='tod-quote'>
                  “Yeni bir dilin, sahici bir dilin önü açılmalıdır.”
                  <cite>Yeşim Eyüboğlu</cite>
                </blockquote>
                <figure className='tod-portrait'>
                  <img src='images/yesim-eyuboglu.jpg' alt='Yeşim Eyüboğlu' loading='lazy' />
                  <figcaption>
                    <strong>Yeşim Eyüboğlu</strong>
                    Kurucu ve genel sanat yönetmeni
                  </figcaption>
                </figure>
              </div>
              <div className='pg-prose' dangerouslySetInnerHTML={{ __html: history.html }} />
            </div>
          </section>
        ) : null}

        {plays.length ? (
          <section className='pg-sun pg-block' aria-labelledby='tod-plays-title'>
            <div className='container'>
              <p className='pg-label'>Repertuvardan</p>
              <h2 id='tod-plays-title' className='pg-heading'>OYUNLAR</h2>
              <ul className='tod-plays'>
                {plays.map((play) => (
                  <li key={play.id} className='tod-play'>
                    <div className='tod-play-photo'>
                      {play.photo ? <img src={play.photo} alt={play.title} loading='lazy' /> : null}
                    </div>
                    <div className='tod-play-body'>
                      <h3 className='tod-play-title'>{upper(play.title)}</h3>
                      <div className='tod-play-text' dangerouslySetInnerHTML={{ __html: play.html }} />                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        ) : null}

        {english ? (
          <section className='pg-night' lang='en'>
            <div className='container'>
              <details className='tod-english'>
                <summary>
                  <span>
                    <span className='pg-label'>In English</span>
                    <span className='tod-english-title'>
                      About Theatre Authentic Experimenting
                    </span>
                  </span>
                  <span className='tod-english-toggle' aria-hidden='true'>+</span>
                </summary>
                <div className='pg-prose' dangerouslySetInnerHTML={{ __html: english.html }} />
              </details>
            </div>
          </section>
        ) : null}
      </div>
      <Footer />
    </React.Fragment>
  )
}
